/**
 * SSE streaming event types matching backend wire format.
 */

export interface StreamStartEvent {
  type: 'stream_start'
  session_id: string
}

export interface TokenEvent {
  type: 'token'
  content: string
}

export interface ToolCallEvent {
  type: 'tool_call'
  tool_name: string
  tool_args?: Record<string, unknown>
}

export interface ToolResultEvent {
  type: 'tool_result'
  tool_name: string
}

export interface StreamEndEvent {
  type: 'stream_end'
  session_id: string
  actions?: Array<{ type: string; data: Record<string, unknown> }>
}

export interface StreamErrorEvent {
  type: 'error'
  message: string
}

export type StreamEvent =
  | StreamStartEvent
  | TokenEvent
  | ToolCallEvent
  | ToolResultEvent
  | StreamEndEvent
  | StreamErrorEvent

/**
 * Human-readable labels for tool names shown during streaming.
 */
export const TOOL_LABELS: Record<string, string> = {
  get_tasks: 'Checking tasks...',
  get_my_tasks: 'Looking up your tasks...',
  get_task_details: 'Fetching task details...',
  create_task: 'Creating task...',
  update_task_status: 'Updating task status...',
  assign_task: 'Assigning task...',
  get_clients: 'Looking up clients...',
  get_client_details: 'Fetching client info...',
  get_statutory_deadlines: 'Checking deadlines...',
  get_statutory_rules: 'Looking up statutory rules...',
  calculate_penalty: 'Calculating penalty...',
  start_timer: 'Starting timer...',
  stop_timer: 'Stopping timer...',
  get_time_summary: 'Checking time logs...',
  get_active_timer: 'Checking active timer...',
  get_firm_context: 'Loading firm context...',
  get_user_context: 'Loading your profile...',
  get_current_datetime: 'Checking current time...',
  notify_user: 'Sending notification...',
  send_email_update: 'Sending email update...',
  send_client_reminder: 'Sending client reminder...',
  get_notification_history: 'Checking notification history...',
  get_user_notification_preferences: 'Checking notification preferences...',
}
